<template>
  <div>
    <button v-for="(option, index) in options"
            :class="{active: value === option.value}"
            :key="index"
            class="button button--field"
            @click="updateValue(option.value)">
    <i :class="[option.className, 'icon icon--button' ]" />{{ option.name }}</button>
  </div>

</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => {
        return [];
      }
    },
    className: {
      type: String,
      default: ''
    }
  },
  data() {
    return {};
  },
  methods: {
    updateValue(value) {
      this.$emit('input', value);
    }
  }
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/InputChoice.vue